// Carriers read the yard's shipments from their own side of the dock: an
// inbound to the yard is a delivery the carrier makes, an outbound is a pickup.
// The resource names stay what the API and every other portal call them; only
// the URLs the carrier sees are renamed, which is why the shipment screens are
// mounted as custom routes (react-admin mounts a resource at /<name>).
//
// Kept apart from carrierRoutes so the screens those routes render can link to
// each other without importing the route table that imports them.
export const DASHBOARD_PATH = "/load-search";
// The company's own profile. A custom route rather than the carriers resource's
// own /carriers/:id, because the session names the company — a dispatcher can
// work for two carriers out of one transload — and because a URL carrying an id
// invites editing another company's entry by pasting a different one.
export const COMPANY_PATH = "/company";
export const DELIVERIES_PATH = "/deliveries";
export const PICKUPS_PATH = "/pickups";
